export const Constants = {
  env:"PROD",
  version:"2.3",
  CoachScreenLimit: 3,
  uatCoachScreenToken: "325131af286f495783e448d5c2852a8c",
  prodCoachScreenToken: "85dcf53015444ab4ad428d3340d8431e",
  agentLogToken:"325131af286f495783e448d5c2852a8c",
  TSAgentServerUrlUAT: "https://dchatsrv.tataplay.com/genesys/cometd",
  TSAgentServerUrl: "https://chat.tataplay.com/genesys/cometd",
  TSAgentChatChannel: "/service/chatV2/customer-support",
  data: {
    operation: "requestChat",
    nickname: "anil",
    firstName: "anil",
    lastName: "",
    subject:
      "1141086460 |3|Bangalore|Karnataka|India|5/25/2021, 6:33:21 PM|2021-05-10",
    userData: {
      insertedID: "FAILURE ",
      _provide_code: "false",
      cti_flowname: "GBM",
      cti_src: "GBM",
      cti_first_name: "anil",
      FirstName: "anil",
      cti_last_name: "",
      LastName: "",
      cti_email_address: "ani02kumar@gmail.com",
      EmailAddress: "ani02kumar@gmail.com ",
      cti_cust_cat: "MASS",
      cti_SubscriberID: "1141086460",
      cti_city: "Bangalore",
      cti_userFirstMessage: "1",
      PhoneNumber: "9741738327",
      IdentifyCreateContact: "3",
      MediaType: "chat",
    },
  },

  litmusUrl:
    "https://app.litmusworld.com/cs/api/api/feedbackrequests/tatasky_initiate_feedback",
  testLitmusData: {
    app_id: "yimd_chat",
    customer_id: "",
    tag_user_type: "Regular",
    tag_city: "",
    tag_subscriberId: "",
    tag_source: "CHAT",
    tag_transType: "Subscriber",
    tag_interactionID: "",
    user_email: "",
    user_phone: "",
    tag_agent_name: "",
    tag_full_name: "",
    tag_transcript: "",
    tag_agentID: "IGSM514853",
  },
  chatHeight: document?.getElementById("top")?.clientHeight,
  chatWidth: document?.getElementById("top")?.clientWidth,
  dormancyMessage:"Seems you are away and we lost the connection.You are a valued TATA Play subscriber and you can reinitiate the chat anytime by typing below. We will be happy to assist you"
};
